import React from 'react';
import { componentMap } from './componentMap';
import { SearchTabProvider } from './SearchTabContext';
import WhatsAppButton from './WhatsAppButton/WhatsAppButton';

function WebsiteRenderer({ 
  layout, branding, companyId, destinations, heroData, headerMenu, footerData,
  mode = "live", viewState = { name: 'home', params: null }, onNavigate,
  templateId, aboutData, contactData
}) {

  if (!layout) return <div>Loading...</div>;

  // 1. MAPPING CORE COMPONENTS
  const TopBar = componentMap[layout.topBar];
  const Header = componentMap[layout.header];
  const Footer = componentMap[layout.footer];



  // 2. DYNAMIC PAGE RESOLVER
  // This looks at the "viewState.name" and finds the right design from the layout JSON
  const renderBody = () => {
    switch (viewState.name) {
      case 'home':
        // Home is special because it usually combines multiple components
        const Hero = componentMap[layout.hero];
        const HomeDestinations = componentMap[layout.destinations];
        const HomePackages = componentMap[layout.packages];
        const AboutComponent = componentMap[layout.aboutUs];
      
        
        return (
          <>
            {Hero && <Hero branding={branding} heroData={heroData} />}
            {HomeDestinations && layout.destinations !== "None" && (
                <HomeDestinations destinations={destinations} />
            )}
            {HomePackages && layout.packages !== "None" && (
                <HomePackages companyId={companyId} mode={mode} onNavigate={onNavigate} templateId={templateId} />
            )}
             {AboutComponent && layout.aboutUs !== "None" && (
                <AboutComponent aboutData={aboutData} />
            )}
            
          </>
        );

      case 'package-details':
        const DetailsPage = componentMap[layout.detailsPage || 'PackageDetails1'];
        return <DetailsPage packageId={viewState.params?.packageId} mode={mode} onNavigate={onNavigate} />;

      default:
        /** 
         * 🔥 THE MAGIC PART 🔥
         * For ANY other page (packages, destinations, flights, hotels, visas):
         * It looks for a key in layout called [pageName]Page 
         * Example: viewState.name 'flights' -> layout.flightsPage
         */
        const pageKey = `${viewState.name}Page`; // e.g. "packagesPage" or "flightsPage"
        const DynamicPageComponent = componentMap[layout[pageKey]];

        if (DynamicPageComponent) {
          return (
            <DynamicPageComponent 
              companyId={companyId} 
              destinations={destinations} 
              branding={branding}     // 👈 PASS BRANDING
              contactData={contactData} // 👈 PASS CONTACT DATA
              mode={mode} 
              onNavigate={onNavigate} 
              templateId={templateId} 
              params={viewState.params}
            />
          );
        }
        
        return <div style={{padding: '100px', textAlign: 'center'}}>Page {viewState.name} design not selected.</div>;
    }
  };

  // 3. THE MASTER WRAPPER (One place for TopBar, Header, and Footer!)
  return (
    <div className="page-wrapper">
      {/* TopBar - One Place */}
      {TopBar && layout.topBar !== "None" && <TopBar branding={branding} companyId={companyId} />}

      <SearchTabProvider>
        {/* Header - One Place */}
        {Header && (
          <Header 
            branding={branding} 
            headerMenu={headerMenu} 
            mode={mode} 
            onNavigate={onNavigate} 
            templateId={templateId} 
          />
        )}

        {/* BODY - Swaps based on URL/State */}
        <main style={{ minHeight: '80vh' }}>
          {renderBody()}
        </main>
      </SearchTabProvider>
      {/* Footer - One Place */}
      {Footer && (
        <Footer 
          branding={branding} 
          companyId={companyId} 
          footerData={footerData} 
          headerMenu={headerMenu}
          onNavigate={onNavigate} 
          mode={mode}
          templateId={templateId} 
        />
      )}
      <WhatsAppButton branding={branding} />
    </div>
  );
}

export default WebsiteRenderer;